import React, { Component } from 'react';
import { API_URL } from '../../constants/api';
import { apiBatchRequest, apiPost } from '../../utils/api_service';
import { ShowToast, toastType } from '../../utils/toast-service';
import commonLabels from '../../constants/messageConstants';
import PageHeader from '../common/PageHeader';
import PageFilter from '../common/PageFilter';
import { GridTable } from '../common/Table/Table';
import { applyFilterOnData, cloneDeep, getCurrentPayCycle, IsSectionVisible, UpdateColumnWithConfiguration } from '../../utils/helper';
import { yearEndComplianceColumn } from '../../constants/MockData';
import { IconButton, Tooltip, Button } from '@material-ui/core';
import { controlType } from '../../constants/common';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import moment from 'moment';
import store from '../../store/appStore';
import { DateFormat, SECTIONS } from '../../constants/appConstants';
import ConfirmDialog from '../common/Dailogbox/confirmDailog';

export class YearEndBonusCompliance extends Component {
  constructor() {
    super();
    this.state = {
      complianceData: [],
      selectedData: [],
      isPopupOpen: false,
      sendEmailToAll: false,
      confirmationMessage: '',
      updateData: undefined,
      configuration: [],
      periodStartDate: null,
      periodEndDate: null,
      defaultSelectedData: [],
      responseComplianceData: [],
      employeeMasterData: [],
      row: undefined
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.LoadData();
  }

  onFilterChange = (selectedData) => {
    const originalSelectedData = this.state.selectedData;
    if (selectedData.find((x) => x.key === 'processYear') === undefined ||
      selectedData.find((x) => x.key === 'processYear').selected === undefined ||
      selectedData.find((x) => x.key === 'processYear').selected <= 0 || (
        selectedData.find((x) => x.key === 'processYear').selected?.length === 1 &&
        selectedData.find((x) => x.key === 'processYear').selected[0]?.processYear === 'Invalid date'
      )) {
      selectedData = selectedData.filter((x) => x.key !== 'processYear');
      selectedData.push({
        type: controlType.Year,
        key: 'processYear',
        selected: [{ processYear: moment().format(DateFormat) }]
      });
    }
    if (selectedData.find((x) => x.key === 'processYear')?.selected[0]?.processYear !==
      originalSelectedData.find((x) => x.key === 'processYear')?.selected[0]?.processYear) {
      this.setState({
        selectedData
      }, () => {
        this.GetComplianceData();
      });
    } else {
      const { responseComplianceData } = this.state;
      const filteredData = applyFilterOnData(
        [...responseComplianceData],
        selectedData
      );

      this.setState({
        complianceData: filteredData || [],
        selectedData: selectedData || []
      });
    }
  }

  GetComplianceData = () => {
    const { selectedData } = this.state;
    const periodStartDate = selectedData?.find((x) => x.key === 'processYear')?.selected[0]?.processYear;
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Users.GetYearEndComplianceStatus + '?periodStartDate=' + moment(periodStartDate).format(DateFormat) + '&ShowAll=' + true,
        key: 'complianceData'
      }
    ])
      .then(
        ({
          complianceData
        }) => {
          this._asyncRequest = null;
          if (complianceData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            this.setState({
              complianceData: applyFilterOnData(cloneDeep(complianceData.data || []), selectedData),
              configuration: complianceData.config,
              responseComplianceData: complianceData.data || []
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  LoadData() {
    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.Employee.GetEmployeeMasterData + '?showInActive=true',
        key: 'employeeMasterData'
      }
    ])
      .then(
        ({
          employeeMasterData
        }) => {
          this._asyncRequest = null;
          if (employeeMasterData.success !== true) {
            ShowToast(
              commonLabels.somethingWrong,
              toastType.ERROR,
              5000,
              500,
              'Server error'
            );
          } else {
            const selectedData = [];
            selectedData.push({
              type: controlType.Year,
              key: 'processYear',
              selected: [{ processYear: moment().format(DateFormat) }]
            });
            this.setState({
              defaultSelectedData: selectedData,
              selectedData,
              employeeMasterData: employeeMasterData.data
            }, () => {
              this.GetComplianceData();
            });
          }
        }
      )
      .catch(() => {
        this._asyncRequest = null;
      });
  }

  openPopup = (isAll, row) => {
    const msg = isAll ? 'Are you sure to send reminder email of Year End Bonus Due to all employees who have not completed the Bonus Estimations/Review?' : 'Are you sure to send reminder email of Year End Bonus Due to the selected employee?';
    this.setState({
      confirmationMessage: <>{msg} </>,
      isPopupOpen: true,
      sendEmailToAll: isAll,
      row: row
    });
  }

  onPopupClickHandle = (isYes) => {
    if (isYes) {
      const { sendEmailToAll, row } = this.state;
      if (sendEmailToAll) {
        this.sendComplianceReminderEmailToAll();
      } else {
        this.sendComplianceReminderEmail(row);
      }
    } else {
      this.setState({
        confirmationMessage: '',
        isPopupOpen: false
      });
    }
  }

  sendComplianceReminderEmailToAll = () => {
    const { responseComplianceData } = this.state;
    const emailComplianceData = [];
    const applicableEmployees = responseComplianceData.filter(x => x.isClosed !== true && x.estimationStatus === false);
    if (applicableEmployees && applicableEmployees.length > 0) {
      const complianceData = {
        date: applicableEmployees[0]?.allocationPeriodEndDate,
        email: applicableEmployees?.map(x => x.userEmail).join('|'),
        status: 'Estimated'
      };
      emailComplianceData.push(complianceData);
    }
    const applicableEmployeesForReview = responseComplianceData.filter(x => x.isClosed !== true && x.estimationStatus === true && x.reviewStatus === false);
    if (applicableEmployeesForReview && applicableEmployeesForReview.length > 0) {
      const complianceData = {
        date: applicableEmployeesForReview[0]?.processEndDate,
        email: applicableEmployeesForReview?.map(x => x.userEmail).join('|'),
        status: 'Reviewed'
      };
      emailComplianceData.push(complianceData);
    }
    this.sendComplianceReminderEmailAPICall(emailComplianceData, true);
  }

  sendComplianceReminderEmail = (row) => {
    const complianceData = [{
      date: row.estimationStatus === false ? row.allocationPeriodEndDate : (row.estimationStatus === true && row.reviewStatus === false) ? row.processEndDate : null,
      email: row.userEmail,
      status: row.estimationStatus === false ? 'Estimated' : (row.estimationStatus === true && row.reviewStatus === false) ? 'Reviewed' : null
    }];
    this.sendComplianceReminderEmailAPICall(complianceData);
  }

  sendComplianceReminderEmailAPICall = (complianceData, toAll = false) => {
    apiPost({
      url: API_URL.Users.SendYearEndBonusComplianceReminderEmail,
      postBody: complianceData
    }).then(({ data: response }) => {
      if (response.success) {
        ShowToast(('Reminder email send successfully' + (toAll ? ' to All.' : '.')), toastType.SUCCESS, 5000, 500);
        this.setState({
          isSave: false,
          confirmationMessage: '',
          isPopupOpen: false,
          row: undefined
        });
      } else {
        ShowToast('Something went wrong.', toastType.ERROR, 5000, 500);
        this.setState({
          isSave: false,
          confirmationMessage: '',
          isPopupOpen: false,
          row: undefined
        });
      }
    });
  }

  renderActionColumn = (row) => {
    return (
      <>
        { IsSectionVisible(SECTIONS.YEAR_END_COMPLIANCE, 0, SECTIONS.ADD_EDIT) && row.isClosed === false && (row.estimationStatus === false || row.reviewStatus === false)
          ? <Tooltip title="Send Reminder">
            <IconButton
              aria-label={'refreshData'}
              size="small"
              onClick={() => {
                this.openPopup(false, row);
              }}
            >
              <MailOutlineIcon fontSize="small" size="small" />
            </IconButton>
          </Tooltip>
          : ''
        }
      </>
    );
  };

  render() {
    const { isPopupOpen, confirmationMessage, complianceData, selectedData, configuration, defaultSelectedData, employeeMasterData } = this.state;
    return (
      <>
        {isPopupOpen && (
          <ConfirmDialog
            IsOpen={isPopupOpen}
            Message={confirmationMessage}
            Title="Reminder Email Confirmation"
            OnHandelClick={(isValid) => {
              if (isValid) {
                this.onPopupClickHandle(isValid);
              } else {
                this.onPopupClickHandle(isValid);
              }
            }}
            AgreeText="Send Email"
            DisAgreeText="Cancel"
          />
        )}
        {<>
          <PageHeader title="Year End Bonus Compliance"></PageHeader>
          <PageFilter
            hidePanel={true}
            autoFilter={false}
            filterAlwaysVisible={true}
            onFilterChanged={this.onFilterChange}
            filterConfig={[
              {
                type: controlType.Year,
                key: 'processYear',
                placeholder: 'Year',
                title: 'Year',
                ignoreSort: true
              },
              {
                multiple: true,
                type: controlType.DropDown,
                source: employeeMasterData,
                key: 'employeeName',
                placeholder: 'Search Employee',
                title: 'Employee',
                additionalIgnoreFilter: 'processYear'
              }
            ]}
            gridColumn={3}
            defaultSelectedData={defaultSelectedData}
            selectedData={selectedData}
          />
          {IsSectionVisible(SECTIONS.YEAR_END_COMPLIANCE, 0, SECTIONS.ADD_EDIT) &&
            complianceData.find(x => x.isClosed === false && (x.estimationStatus === false || x.reviewStatus === false)) !== undefined &&
            <div className="row table-list-container">
              <Button
                variant="contained"
                color="primary"
                size="small"
                className='pull-right'
                onClick={() => {
                  this.openPopup(true, undefined);
                }}
              >
                Send Reminder to All
            </Button>
            </div>
          }
          <div className="row table-list-container">
            <GridTable
              columns={UpdateColumnWithConfiguration(
                yearEndComplianceColumn,
                configuration
              )}
              data={complianceData || []}
              renderActionColumn={this.renderActionColumn}
            ></GridTable>
          </div>
        </>}
      </>
    );
  }
}

export default YearEndBonusCompliance;
